<template>
  <swiper-slide class="eco-carousel-item">
    <a
      class=""
      :href="
        !resource_link
          ? 'https://eco.ca/?p=' + report.ID
          : report['wpcf-ebook-guide-document-link']
      "
      target="_blank"
    >
      <img
        :src="report['cover-page-image']"
        :class="'eco-carousel-item--image' + (learningRow ? ' img-cover' : '')"
        alt="..."
      />
      <div class="eco-carousel-item--content h-100 p-4 pb-2">
        <h6 class="fw-bold" :title="report.post_title">
          {{
            report.post_title.length > 40 && !hover
              ? report.post_title.substring(0, 40) + "..."
              : report.post_title
          }}
        </h6>
        <h6 class="mb-2 text-muted small" v-if="!learningRow">
          {{
            new Date(report.post_date).toLocaleDateString("en-CA", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          }}
        </h6>
        <div class="mb-2 small" v-if="learningRow">
          {{ report["event-type"] }} for {{ report["career-stage-friendly"] }}
        </div>
        <p
          class="text-muted small"
          v-html="
            report['description-overview']
              .replace(/<[^>]*>?/gm, '')
              .substring(0, 180) + '...'
          "
          v-if="learningRow && report['description-overview']"
        ></p>

        <div
          class="mt-3 text-muted small d-block align-items-center"
          v-if="learningRow"
        >
          <h6>
            <span class="badge badge-pill bg-success">
              <b>
                {{ language.includes('en') ? "Members:" : "Membres:" }}
                </b> {{ report["member-price"] }}
            </span>
          </h6>
          <h6>
            <span class="badge badge-pill bg-light text-muted" v-if='report["non-member-price"]'>
              <b>
                {{ language.includes('en') ? "Regular:" : "Ordinaire:" }}
                </b> {{ report["non-member-price"] }}
            </span>
          </h6>
        </div>
        <p :title="report.post_excerpt">
          {{ report.post_excerpt }}
        </p>

        <a
          :href="'https://eco.ca/?p=' + report.ID"
          target="_blank"
          role="button"
          class="btn btn-success text-white p-3 access-btn"
          v-if="resource_link"
        >
          <i class="fa fa-download me-3"></i> Access Report
        </a>
        <a
          :href="report['wpcf-ebook-guide-document-link']"
          target="_blank"
          role="button"
          class="btn btn-success text-white p-3 access-btn"
          v-if="!resource_link && !learningRow"
        >
          <i class="fa fa-download me-3"></i> View Resource
        </a>
        <a
          :href="report['wpcf-ebook-guide-document-link']"
          target="_blank"
          role="button"
          class="btn btn-success text-white p-3 access-btn"
          v-if="learningRow"
        >
          <i class="fa fa-pencil-square-o me-3"></i>
          {{ report["button-text"] ? report["button-text"] : "Learn More" }}
        </a>
      </div>
    </a>
  </swiper-slide>
</template>


<script>
 import { SwiperSlide } from 'vue-awesome-swiper'
export default {
  components:{
    SwiperSlide,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },

    learningRow: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    resource_link() {
      if (this.report["wpcf-ebook-guide-document-link"]) {
        if (this.report["wpcf-ebook-guide-document-link"].length > 0) {
          return true;
        } else return false;
      }
      return false;
    },
     language() {
      return this.getCookie("pll_language") ? this.getCookie("pll_language") : "en";
    },
  },
  methods: {
    getCookie(name) {
      var dc, prefix, begin, end;

      dc = document.cookie;
      prefix = name + "=";
      begin = dc.indexOf("; " + prefix);
      end = dc.length; // default to end of the string

      if (begin !== -1) {
        begin += 2;
      } else {
        begin = dc.indexOf(prefix);
        if (begin === -1 || begin !== 0) return null;
      }

      if (dc.indexOf(";", begin) !== -1) {
        end = dc.indexOf(";", begin);
      }

      return decodeURI(dc.substring(begin + prefix.length, end)).replace(
        /\"/g,
        ""
      );
    },
  },

};
</script>

<style>
</style>